// 垃圾桶 / trash bin. 店长以上.
//
// Soft-deleted tasks land here (delete is a soft delete now — see
// worker/src/routes/tasks.ts). Deleting a main project soft-deletes its whole
// subtree, which shows here as ONE entry (the topmost deleted node) with a
// "+N 子项" count. From here a manager can:
//   * 恢复     — restore the subtree (reappears in 待办)
//   * 彻底删除 — permanent hard delete + drops the R2 files (irreversible)

import { useEffect, useState } from 'react';
import * as api from '../lib/api.ts';
import { Toast } from '../components/atoms.jsx';
import { Icon } from '../components/Icon.jsx';
import { confirmDialog } from '../lib/confirm.js';

function fmtWhen(s) {
  return typeof s === 'string' ? s.replace('T', ' ').slice(0, 16) : '';
}

export const TrashView = ({ staff = [], onChanged }) => {
  const [list, setList] = useState(null);
  const [err, setErr] = useState('');
  const [toast, setToast] = useState(null);
  const [busy, setBusy] = useState(null); // id currently being acted on

  async function load() {
    setErr('');
    try { setList(await api.listTrash()); }
    catch (e) { setErr(e?.message || '加载失败'); }
  }
  useEffect(() => { load(); /* eslint-disable-line */ }, []);

  function whoName(id) {
    return staff.find(s => s.id === id)?.name || id || '—';
  }

  async function onRestore(t) {
    setBusy(t.id);
    try {
      await api.restoreTask(t.id);
      setToast({ kind: 'success', msg: '已恢复' });
      setList(l => (l || []).filter(x => x.id !== t.id));
      onChanged && onChanged();
    } catch (e) {
      setToast({ kind: 'error', msg: e?.message || '恢复失败' });
    } finally { setBusy(null); }
  }

  async function onPurge(t) {
    const extra = t.childCount > 0 ? `（含 ${t.childCount} 个子项）` : '';
    if (!await confirmDialog({ title: '彻底删除', kind: 'danger', confirmLabel: '彻底删除', message: `彻底删除「${t.title}」${extra}？\n此操作无法撤销，附件也会一并删除。` })) return;
    setBusy(t.id);
    try {
      await api.purgeTask(t.id);
      setToast({ kind: 'success', msg: '已彻底删除' });
      setList(l => (l || []).filter(x => x.id !== t.id));
    } catch (e) {
      setToast({ kind: 'error', msg: e?.message || '删除失败' });
    } finally { setBusy(null); }
  }

  return (
    <>
      <div className="vava-page-header">
        <div>
          <h1 className="vava-page-title"><span style={{ marginRight: 10 }}>🗑️</span>已删除</h1>
          <div className="vava-page-meta">删除的待办会保留在这里，可以恢复或彻底删除。删除主项目会连同它的子项一起进来。</div>
        </div>
      </div>

      {err && <div className="att-error" role="alert">{err}</div>}

      {list === null ? (
        <div className="vava-card empty-state"><div className="title">加载中…</div></div>
      ) : list.length === 0 ? (
        <div className="vava-card empty-state">
          <div className="emoji">🗑️</div>
          <div className="title">垃圾桶是空的</div>
          <div className="sub">删除的待办会出现在这里，随时可以恢复</div>
        </div>
      ) : (
        <div className="trash-list">
          {list.map(t => (
            <div key={t.id} className="trash-item">
              <div className="trash-main">
                <div className="trash-title">
                  {t.title}
                  {t.childCount > 0 && <span className="trash-kids mono"> +{t.childCount} 子项</span>}
                </div>
                <div className="trash-sub mono">
                  {t.groupName ? t.groupName + ' · ' : ''}删除于 {fmtWhen(t.deletedAt)} · 由 {t.deletedByName || whoName(t.deletedBy)}
                </div>
              </div>
              <div className="trash-actions">
                <button className="btn btn-ghost" disabled={busy === t.id} onClick={() => onRestore(t)}>
                  <Icon name="restore" /> 恢复
                </button>
                <button className="btn btn-ghost trash-purge" disabled={busy === t.id} onClick={() => onPurge(t)}>
                  <Icon name="trash" /> 彻底删除
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {toast && <Toast message={toast.msg} kind={toast.kind} onDone={() => setToast(null)} />}
    </>
  );
};
